export default "__VITE_ASSET__1pBs0b5O__"